import { render, staticRenderFns } from "./SysCheckRuleModal.vue?vue&type=template&id=08af2f46&scoped=true"
import script from "./SysCheckRuleModal.vue?vue&type=script&lang=js"
export * from "./SysCheckRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af2f46",
  null
  
)

export default component.exports